import { Injectable } from '@angular/core';
import { HookEvent, HookHandlerAbstract, HookPriority, LaunchedHook } from '@lobos/library';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { FavoriteHelperService } from '../../../services/favorite/favorite-helper.service';

type type = LaunchedHook;

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class LaunchedLoadActiveFavoritesHandler extends HookHandlerAbstract<type, Observable<boolean>> {
  constructor(private favoriteHelper: FavoriteHelperService) {
    super();
  }

  override priority(): number {
    return HookPriority.HIGHEST;
  }

  ids(): type[] {
    return [{ type: 'LaunchedHook' }];
  }

  override after(event: HookEvent<type, Observable<boolean>>, result: Observable<boolean>): Observable<boolean> {
    this.favoriteHelper.initializeFavorites().pipe(untilDestroyed(this)).subscribe();

    return super.after(event, result);
  }
}
